/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ApprovalContractDto,
  CompleteSigningRequest,
  ContractDetails,
  ContractDtoPaginatedData,
  ContractTrackingTimelineDto,
  ContractTrackingWorkflowDto,
  ContractsGetApprovalContractsParams,
  ContractsGetAvailableWorkflowsParams,
  ContractsGetContractDetailsParams,
  ContractsGetContractTableParams,
  ContractsGetContractTrackingWorkflowStepsParams,
  ContractsSendNotificationsAndEmailsParams,
  CreateContractTrackingRequest,
  ProfileContract,
  SetDeadlineRequest,
  StartSigningRequest
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getContractsGetProfileContractsUrl = () => {


  

  return `/api/Contracts/GetProfileContracts`
}

export const contractsGetProfileContracts = async ( options?: RequestInit): Promise<ProfileContract[]> => {
  
  return customInstance<ProfileContract[]>(getContractsGetProfileContractsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsGetProfileContractsQueryKey = () => {
    return [
    `/api/Contracts/GetProfileContracts`
    ] as const;
    }

    
export const getContractsGetProfileContractsQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetProfileContractsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetProfileContracts>>> = ({ signal }) => contractsGetProfileContracts({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetProfileContractsQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetProfileContracts>>>
export type ContractsGetProfileContractsQueryError = ErrorType<unknown>


export function useContractsGetProfileContracts<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetProfileContracts>>,
          TError,
          Awaited<ReturnType<typeof contractsGetProfileContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetProfileContracts<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetProfileContracts>>,
          TError,
          Awaited<ReturnType<typeof contractsGetProfileContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetProfileContracts<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetProfileContracts<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetProfileContractsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetProfileContractsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetProfileContractsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetProfileContracts>>> = ({ signal }) => contractsGetProfileContracts({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetProfileContractsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetProfileContracts>>>
export type ContractsGetProfileContractsSuspenseQueryError = ErrorType<unknown>


export function useContractsGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetProfileContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetProfileContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetProfileContractsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetContractTableUrl = (params?: ContractsGetContractTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["departmentTreeNodes","contractTypeTreeNodes","contractStatusIds","personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractTable?${stringifiedParams}` : `/api/Contracts/GetContractTable`
}

export const contractsGetContractTable = async (params?: ContractsGetContractTableParams, options?: RequestInit): Promise<ContractDtoPaginatedData> => {
  
  return customInstance<ContractDtoPaginatedData>(getContractsGetContractTableUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsGetContractTableQueryKey = (params?: ContractsGetContractTableParams,) => {
    return [
    `/api/Contracts/GetContractTable`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsGetContractTableQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(params?: ContractsGetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetContractTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetContractTable>>> = ({ signal }) => contractsGetContractTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetContractTableQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetContractTable>>>
export type ContractsGetContractTableQueryError = ErrorType<unknown>


export function useContractsGetContractTable<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params: undefined |  ContractsGetContractTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetContractTable>>,
          TError,
          Awaited<ReturnType<typeof contractsGetContractTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTable<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetContractTable>>,
          TError,
          Awaited<ReturnType<typeof contractsGetContractTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTable<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetContractTable<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetContractTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetContractTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(params?: ContractsGetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetContractTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetContractTable>>> = ({ signal }) => contractsGetContractTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetContractTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetContractTable>>>
export type ContractsGetContractTableSuspenseQueryError = ErrorType<unknown>


export function useContractsGetContractTableSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params: undefined |  ContractsGetContractTableParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTableSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTableSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetContractTableSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTable>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractTableParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetContractTableSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetContractDetailsUrl = (params?: ContractsGetContractDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractDetails?${stringifiedParams}` : `/api/Contracts/GetContractDetails`
}

export const contractsGetContractDetails = async (params?: ContractsGetContractDetailsParams, options?: RequestInit): Promise<ContractDetails> => {
  
  return customInstance<ContractDetails>(getContractsGetContractDetailsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsGetContractDetailsQueryKey = (params?: ContractsGetContractDetailsParams,) => {
    return [
    `/api/Contracts/GetContractDetails`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsGetContractDetailsQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetContractDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetContractDetails>>> = ({ signal }) => contractsGetContractDetails(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetContractDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetContractDetails>>>
export type ContractsGetContractDetailsQueryError = ErrorType<unknown>


export function useContractsGetContractDetails<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  ContractsGetContractDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetContractDetails>>,
          TError,
          Awaited<ReturnType<typeof contractsGetContractDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractDetails<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetContractDetails>>,
          TError,
          Awaited<ReturnType<typeof contractsGetContractDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractDetails<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetContractDetails<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetContractDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetContractDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetContractDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetContractDetails>>> = ({ signal }) => contractsGetContractDetails(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetContractDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetContractDetails>>>
export type ContractsGetContractDetailsSuspenseQueryError = ErrorType<unknown>


export function useContractsGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  ContractsGetContractDetailsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetContractDetailsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractDetails>>, TError = ErrorType<unknown>>(
 params?: ContractsGetContractDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetContractDetailsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetApprovalContractsUrl = (params?: ContractsGetApprovalContractsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetApprovalContracts?${stringifiedParams}` : `/api/Contracts/GetApprovalContracts`
}

export const contractsGetApprovalContracts = async (params?: ContractsGetApprovalContractsParams, options?: RequestInit): Promise<ApprovalContractDto[]> => {
  
  return customInstance<ApprovalContractDto[]>(getContractsGetApprovalContractsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsGetApprovalContractsQueryKey = (params?: ContractsGetApprovalContractsParams,) => {
    return [
    `/api/Contracts/GetApprovalContracts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsGetApprovalContractsQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetApprovalContractsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetApprovalContracts>>> = ({ signal }) => contractsGetApprovalContracts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetApprovalContractsQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetApprovalContracts>>>
export type ContractsGetApprovalContractsQueryError = ErrorType<unknown>


export function useContractsGetApprovalContracts<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params: undefined |  ContractsGetApprovalContractsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetApprovalContracts>>,
          TError,
          Awaited<ReturnType<typeof contractsGetApprovalContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetApprovalContracts<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetApprovalContracts>>,
          TError,
          Awaited<ReturnType<typeof contractsGetApprovalContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetApprovalContracts<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetApprovalContracts<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetApprovalContractsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetApprovalContractsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetApprovalContractsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetApprovalContracts>>> = ({ signal }) => contractsGetApprovalContracts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetApprovalContractsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetApprovalContracts>>>
export type ContractsGetApprovalContractsSuspenseQueryError = ErrorType<unknown>


export function useContractsGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params: undefined |  ContractsGetApprovalContractsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetApprovalContractsSuspense<TData = Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError = ErrorType<unknown>>(
 params?: ContractsGetApprovalContractsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetApprovalContracts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetApprovalContractsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetAvailableWorkflowsUrl = (params: ContractsGetAvailableWorkflowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetAvailableWorkflows?${stringifiedParams}` : `/api/Contracts/GetAvailableWorkflows`
}

export const contractsGetAvailableWorkflows = async (params: ContractsGetAvailableWorkflowsParams, options?: RequestInit): Promise<ContractTrackingWorkflowDto[]> => {
  
  return customInstance<ContractTrackingWorkflowDto[]>(getContractsGetAvailableWorkflowsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsGetAvailableWorkflowsQueryKey = (params?: ContractsGetAvailableWorkflowsParams,) => {
    return [
    `/api/Contracts/GetAvailableWorkflows`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsGetAvailableWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetAvailableWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>> = ({ signal }) => contractsGetAvailableWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetAvailableWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>>
export type ContractsGetAvailableWorkflowsQueryError = ErrorType<unknown>


export function useContractsGetAvailableWorkflows<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>,
          TError,
          Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetAvailableWorkflows<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>,
          TError,
          Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetAvailableWorkflows<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetAvailableWorkflows<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetAvailableWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetAvailableWorkflowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetAvailableWorkflowsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>> = ({ signal }) => contractsGetAvailableWorkflows(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetAvailableWorkflowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>>
export type ContractsGetAvailableWorkflowsSuspenseQueryError = ErrorType<unknown>


export function useContractsGetAvailableWorkflowsSuspense<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetAvailableWorkflowsSuspense<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetAvailableWorkflowsSuspense<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetAvailableWorkflowsSuspense<TData = Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError = ErrorType<unknown>>(
 params: ContractsGetAvailableWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetAvailableWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetAvailableWorkflowsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsCreateContractTrackingUrl = () => {


  

  return `/api/Contracts/CreateContractTracking`
}

export const contractsCreateContractTracking = async (createContractTrackingRequest: CreateContractTrackingRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getContractsCreateContractTrackingUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createContractTrackingRequest,)
  }
);}




export const getContractsCreateContractTrackingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsCreateContractTracking>>, TError,{data: BodyType<CreateContractTrackingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsCreateContractTracking>>, TError,{data: BodyType<CreateContractTrackingRequest>}, TContext> => {

const mutationKey = ['contractsCreateContractTracking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsCreateContractTracking>>, {data: BodyType<CreateContractTrackingRequest>}> = (props) => {
          const {data} = props ?? {};

          return  contractsCreateContractTracking(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsCreateContractTrackingMutationResult = NonNullable<Awaited<ReturnType<typeof contractsCreateContractTracking>>>
    export type ContractsCreateContractTrackingMutationBody = BodyType<CreateContractTrackingRequest>
    export type ContractsCreateContractTrackingMutationError = ErrorType<unknown>

    export const useContractsCreateContractTracking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsCreateContractTracking>>, TError,{data: BodyType<CreateContractTrackingRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsCreateContractTracking>>,
        TError,
        {data: BodyType<CreateContractTrackingRequest>},
        TContext
      > => {

      const mutationOptions = getContractsCreateContractTrackingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getContractsSendNotificationsAndEmailsUrl = (params: ContractsSendNotificationsAndEmailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/SendNotificationsAndEmails?${stringifiedParams}` : `/api/Contracts/SendNotificationsAndEmails`
}

export const contractsSendNotificationsAndEmails = async (params: ContractsSendNotificationsAndEmailsParams, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getContractsSendNotificationsAndEmailsUrl(params),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getContractsSendNotificationsAndEmailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsSendNotificationsAndEmails>>, TError,{params: ContractsSendNotificationsAndEmailsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsSendNotificationsAndEmails>>, TError,{params: ContractsSendNotificationsAndEmailsParams}, TContext> => {

const mutationKey = ['contractsSendNotificationsAndEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsSendNotificationsAndEmails>>, {params: ContractsSendNotificationsAndEmailsParams}> = (props) => {
          const {params} = props ?? {};

          return  contractsSendNotificationsAndEmails(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsSendNotificationsAndEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof contractsSendNotificationsAndEmails>>>
    
    export type ContractsSendNotificationsAndEmailsMutationError = ErrorType<unknown>

    export const useContractsSendNotificationsAndEmails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsSendNotificationsAndEmails>>, TError,{params: ContractsSendNotificationsAndEmailsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsSendNotificationsAndEmails>>,
        TError,
        {params: ContractsSendNotificationsAndEmailsParams},
        TContext
      > => {

      const mutationOptions = getContractsSendNotificationsAndEmailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getContractsGetContractTrackingWorkflowStepsUrl = (params: ContractsGetContractTrackingWorkflowStepsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Contracts/GetContractTrackingWorkflowSteps?${stringifiedParams}` : `/api/Contracts/GetContractTrackingWorkflowSteps`
}

export const contractsGetContractTrackingWorkflowSteps = async (params: ContractsGetContractTrackingWorkflowStepsParams, options?: RequestInit): Promise<ContractTrackingTimelineDto[]> => {
  
  return customInstance<ContractTrackingTimelineDto[]>(getContractsGetContractTrackingWorkflowStepsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getContractsGetContractTrackingWorkflowStepsQueryKey = (params?: ContractsGetContractTrackingWorkflowStepsParams,) => {
    return [
    `/api/Contracts/GetContractTrackingWorkflowSteps`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getContractsGetContractTrackingWorkflowStepsQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetContractTrackingWorkflowStepsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>> = ({ signal }) => contractsGetContractTrackingWorkflowSteps(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetContractTrackingWorkflowStepsQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>>
export type ContractsGetContractTrackingWorkflowStepsQueryError = ErrorType<unknown>


export function useContractsGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>,
          TError,
          Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>,
          TError,
          Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetContractTrackingWorkflowSteps<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetContractTrackingWorkflowStepsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsGetContractTrackingWorkflowStepsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContractsGetContractTrackingWorkflowStepsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>> = ({ signal }) => contractsGetContractTrackingWorkflowSteps(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ContractsGetContractTrackingWorkflowStepsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>>
export type ContractsGetContractTrackingWorkflowStepsSuspenseQueryError = ErrorType<unknown>


export function useContractsGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useContractsGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useContractsGetContractTrackingWorkflowStepsSuspense<TData = Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError = ErrorType<unknown>>(
 params: ContractsGetContractTrackingWorkflowStepsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof contractsGetContractTrackingWorkflowSteps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getContractsGetContractTrackingWorkflowStepsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getContractsSetDeadlineUrl = () => {


  

  return `/api/Contracts/SetDeadline`
}

export const contractsSetDeadline = async (setDeadlineRequest: SetDeadlineRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getContractsSetDeadlineUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setDeadlineRequest,)
  }
);}




export const getContractsSetDeadlineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsSetDeadline>>, TError,{data: BodyType<SetDeadlineRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsSetDeadline>>, TError,{data: BodyType<SetDeadlineRequest>}, TContext> => {

const mutationKey = ['contractsSetDeadline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsSetDeadline>>, {data: BodyType<SetDeadlineRequest>}> = (props) => {
          const {data} = props ?? {};

          return  contractsSetDeadline(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsSetDeadlineMutationResult = NonNullable<Awaited<ReturnType<typeof contractsSetDeadline>>>
    export type ContractsSetDeadlineMutationBody = BodyType<SetDeadlineRequest>
    export type ContractsSetDeadlineMutationError = ErrorType<unknown>

    export const useContractsSetDeadline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsSetDeadline>>, TError,{data: BodyType<SetDeadlineRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsSetDeadline>>,
        TError,
        {data: BodyType<SetDeadlineRequest>},
        TContext
      > => {

      const mutationOptions = getContractsSetDeadlineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getContractsStartSigningUrl = () => {


  

  return `/api/Contracts/StartSigning`
}

export const contractsStartSigning = async (startSigningRequest: StartSigningRequest, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getContractsStartSigningUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startSigningRequest,)
  }
);}




export const getContractsStartSigningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsStartSigning>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsStartSigning>>, TError,{data: BodyType<StartSigningRequest>}, TContext> => {

const mutationKey = ['contractsStartSigning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsStartSigning>>, {data: BodyType<StartSigningRequest>}> = (props) => {
          const {data} = props ?? {};

          return  contractsStartSigning(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsStartSigningMutationResult = NonNullable<Awaited<ReturnType<typeof contractsStartSigning>>>
    export type ContractsStartSigningMutationBody = BodyType<StartSigningRequest>
    export type ContractsStartSigningMutationError = ErrorType<unknown>

    export const useContractsStartSigning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsStartSigning>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsStartSigning>>,
        TError,
        {data: BodyType<StartSigningRequest>},
        TContext
      > => {

      const mutationOptions = getContractsStartSigningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getContractsStartSigningExternalUrl = () => {


  

  return `/api/Contracts/StartSigningExternal`
}

export const contractsStartSigningExternal = async (startSigningRequest: StartSigningRequest, options?: RequestInit): Promise<string> => {
  
  return customInstance<string>(getContractsStartSigningExternalUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      startSigningRequest,)
  }
);}




export const getContractsStartSigningExternalMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsStartSigningExternal>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsStartSigningExternal>>, TError,{data: BodyType<StartSigningRequest>}, TContext> => {

const mutationKey = ['contractsStartSigningExternal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsStartSigningExternal>>, {data: BodyType<StartSigningRequest>}> = (props) => {
          const {data} = props ?? {};

          return  contractsStartSigningExternal(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsStartSigningExternalMutationResult = NonNullable<Awaited<ReturnType<typeof contractsStartSigningExternal>>>
    export type ContractsStartSigningExternalMutationBody = BodyType<StartSigningRequest>
    export type ContractsStartSigningExternalMutationError = ErrorType<unknown>

    export const useContractsStartSigningExternal = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsStartSigningExternal>>, TError,{data: BodyType<StartSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsStartSigningExternal>>,
        TError,
        {data: BodyType<StartSigningRequest>},
        TContext
      > => {

      const mutationOptions = getContractsStartSigningExternalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getContractsCompleteSigningUrl = () => {


  

  return `/api/Contracts/CompleteSigning`
}

export const contractsCompleteSigning = async (completeSigningRequest: CompleteSigningRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getContractsCompleteSigningUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      completeSigningRequest,)
  }
);}




export const getContractsCompleteSigningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsCompleteSigning>>, TError,{data: BodyType<CompleteSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsCompleteSigning>>, TError,{data: BodyType<CompleteSigningRequest>}, TContext> => {

const mutationKey = ['contractsCompleteSigning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsCompleteSigning>>, {data: BodyType<CompleteSigningRequest>}> = (props) => {
          const {data} = props ?? {};

          return  contractsCompleteSigning(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsCompleteSigningMutationResult = NonNullable<Awaited<ReturnType<typeof contractsCompleteSigning>>>
    export type ContractsCompleteSigningMutationBody = BodyType<CompleteSigningRequest>
    export type ContractsCompleteSigningMutationError = ErrorType<unknown>

    export const useContractsCompleteSigning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsCompleteSigning>>, TError,{data: BodyType<CompleteSigningRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsCompleteSigning>>,
        TError,
        {data: BodyType<CompleteSigningRequest>},
        TContext
      > => {

      const mutationOptions = getContractsCompleteSigningMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getContractsUploadContractUrl = () => {


  

  return `/api/Contracts/UploadContract`
}

export const contractsUploadContract = async (contractsUploadContractBody: number, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getContractsUploadContractUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      contractsUploadContractBody,)
  }
);}




export const getContractsUploadContractMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsUploadContract>>, TError,{data: BodyType<number>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof contractsUploadContract>>, TError,{data: BodyType<number>}, TContext> => {

const mutationKey = ['contractsUploadContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contractsUploadContract>>, {data: BodyType<number>}> = (props) => {
          const {data} = props ?? {};

          return  contractsUploadContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContractsUploadContractMutationResult = NonNullable<Awaited<ReturnType<typeof contractsUploadContract>>>
    export type ContractsUploadContractMutationBody = BodyType<number>
    export type ContractsUploadContractMutationError = ErrorType<unknown>

    export const useContractsUploadContract = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contractsUploadContract>>, TError,{data: BodyType<number>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contractsUploadContract>>,
        TError,
        {data: BodyType<number>},
        TContext
      > => {

      const mutationOptions = getContractsUploadContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    